import { keys as parentKeys } from '@copro/api';

const all = [...parentKeys.all, 'calendar'] as const;

export const keys = {
  all,
  list: () => [...all, 'list'] as const,
  getCalendarItemsByDate: (minDate: string, maxDate: string, spaceId: string) => [...keys.list(), { minDate, maxDate, spaceId }] as const,
};
